module.exports = __webpack_public_path__ + "static/Map-ec120fea822d4cd7e9e0e646b6f39ca0.png";